/* src/app/forms/produtos/mercadolivre/meli-edit-form-multi-table/meli-edit-form-multi-table.component.scss */
:host {
  height: 100%;
}
.multi-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.table-divider {
  margin: 4px 0;
}
.button-table-action {
  display: flex;
  flex-direction: column;
  background-color: var(--tem-surface-2, rgba(0, 0, 0, 0.05));
  height: 35px;
  padding: 4px;
  justify-content: center;
}
.button-table-action button {
  padding: 0 15px;
  font-size: 0.8em;
  line-height: 24px !important;
  width: 30%;
}
.spacer {
  flex: 1;
}
.info {
  text-align: center;
  color: var(--tem-deep, black);
  font-weight: 500;
  align-self: center;
  margin-right: 6px;
}
.info.data {
  border: 1px solid var(--tem-border, #e9ecef);
  background: var(--tem-surface, #fff);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 5px 10px;
  font-size: var(--tem-fs-sm, 80%);
}
.table-multi {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.grid-row {
  display: grid;
  gap: 15px;
  width: 100%;
  align-items: center;
}
.header-line {
  display: grid;
  width: 100%;
  margin: 0.5rem 0;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 20px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.02);
  background: var(--tem-surface, #fff);
}
.header-row {
  height: 60px;
}
.header {
  font-size: var(--tem-fs-sm, 90%);
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  max-width: 124px;
  max-height: 50px;
  margin: 0 auto;
}
.grid-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
}
.variation-grid {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-right: 12px;
  margin-bottom: 50px;
}
.lines {
  display: grid;
  height: 40px;
  overflow: hidden;
  border-bottom: 1px solid var(--tem-border, #e9ecef);
  padding-left: 5px;
  padding-right: 5px;
}
.lines:hover {
  background: var(--tem-surface-2, rgba(0, 0, 0, 0.03));
}
.checkbox-col {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.data-text,
.data-int,
.data-float,
.data-date {
  font-size: var(--tem-fs-md, 100%);
  font-weight: 200;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  width: 100%;
  max-width: 124px;
  max-height: 40px;
  margin: 0 auto;
}
/*# sourceMappingURL=meli-edit-form-multi-table.component.css.map */
